module.exports = __webpack_public_path__ + "static/media/UserGray.5811413e.svg";